;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';
import { Col, Row } from 'reactstrap';
import dayjs from '../../utils/dayjs';
import slugify from 'slugify';
import { MdAccessTime, MdArrowForward, MdOutlinePlace, MdOutlineSell } from 'react-icons/md';
import { addBreadcrumb } from '@sentry/nextjs';
import htmlToDescription from '../../utils/htmlToDescription';
import capitalizeFirstLetter from '../../utils/capitalizeFirstLetter';
import capitalizePlaceName from '../../utils/capitalizePlaceName';
import JobLikeButton from '../JobLikeButton';
import { useUser } from '../../contexts/UserContext';
import { getI18nUtils } from '../../i18n/i18n-utils';
import { Dictionaries } from '../../i18n/i18n-config';

function JobTeaser({
  job,
  titleTag = 'h2',
  layout = 'list',
  dictionary,
}: {
  job: Job | JobMatch;
  titleTag?: string;
  layout?: 'grid' | 'list';
  dictionary: Partial<Dictionaries>;
}): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);
  const user = useUser();
  const hasApplied = user?.jobApplications?.some((application) => application.job?._id === job.id);

  const { id, title, description, updated, location, domains, laborRegime, language } = job;
  if (!title || typeof title !== 'string') {
    addBreadcrumb({
      category: 'job-teaser',
      data: job,
      level: 'debug',
      message: 'job found without title',
    });
  }

  const grid = layout === 'grid';

  let href = `/${language}/`;
  if (title) href = `/${language}/jobs/${id}/${slugify(title, { lower: true })}`;
  else if (title && process.env.NEXT_PUBLIC_APP === 'werkenbijsynergie.be')
    href = `/jobs/${id}/${slugify(title, { lower: true })}`;

  return (
    <Col xs={12} md={grid ? 6 : 12} lg={grid ? 4 : 12} className="mb-3">
      <div className="jobTeaser border p-4 rounded h-100">
        <Link
          className="d-flex flex-column justify-content-between text-dark text-decoration-none h-100"
          href={href}
          locale={language}
        >
          <div className="d-flex flex-column h-100 justify-content-end">
            <div className="h-100 d-flex flex-column">
              <div className="d-flex justify-content-between w-100 mb-2">
                {title &&
                  (() => {
                    switch (titleTag) {
                      case 'h2':
                        return <h2 className="card-title text-break mt-0 me-3 mb-2 h4">{capitalizeFirstLetter(title)}</h2>;
                      case 'h3':
                        return <h3 className="card-title text-break mt-0 me-3 mb-2 h4">{capitalizeFirstLetter(title)}</h3>;
                      case 'h4':
                        return <h4 className="card-title text-break mt-0 me-3 mb-2 h4">{capitalizeFirstLetter(title)}</h4>;
                      case 'h5':
                        return <h5 className="card-title text-break mt-0 me-3 mb-2 h4">{capitalizeFirstLetter(title)}</h5>;
                      default:
                        return <h2 className="card-title text-break mt-0 me-3 mb-2 h4">{capitalizeFirstLetter(title)}</h2>;
                    }
                  })()}
                <div className="d-flex jobteaser-actions align-items-start">
                  {!grid && hasApplied && (
                    <div className="pill pill-success me-2 d-none d-md-block">{formatMessage({ id: 'status_applied' })}</div>
                  )}
                  <JobLikeButton job={job} dictionary={dictionary} />
                </div>
              </div>
              <p className="jobteaser-description mb-3">{htmlToDescription(description, 0, 180)}</p>
            </div>
            <Row className={`d-flex ${grid ? 'flex-column' : 'flex-column flex-md-row'}`}>
              {location && location.city && (
                <Col xs={grid ? 12 : 'auto'} className={`d-flex align-items-center ${grid ? 'mb-2' : 'mb-2 mb-md-0'}`}>
                  <MdOutlinePlace className="me-2" />
                  <span>{capitalizePlaceName(location.city)}</span>
                </Col>
              )}
              {(domains || laborRegime) && (
                <Col
                  xs={grid ? 12 : 'auto'}
                  className={`domain-regime d-flex align-items-center ${grid ? 'mb-2' : 'mb-2 mb-md-0'}`}
                >
                  <MdOutlineSell className="me-2" />
                  {domains && domains[0] && <span>{capitalizeFirstLetter(formatMessage({ id: domains[0] }))}</span>}
                  {laborRegime && <span>{capitalizeFirstLetter(formatMessage({ id: laborRegime }))}</span>}
                </Col>
              )}
              {updated && (
                <Col xs={grid ? 12 : 'auto'} className={`d-flex align-items-center ${grid ? 'mb-2' : 'mb-2 mb-md-0'}`}>
                  <MdAccessTime className="me-2" />
                  <span>{dayjs(updated).fromNow()}</span>
                </Col>
              )}
              <Col className={`d-flex justify-content-between justify-content-md-end ms-auto ${grid ? 'd-none' : 'd-block'}`}>
                {hasApplied ? (
                  <div className="pill pill-success me-2 d-md-none">{formatMessage({ id: 'status_applied' })}</div>
                ) : (
                  <div />
                )}
                <MdArrowForward size={18} />
              </Col>
            </Row>
          </div>

          {grid && (
            <div>
              <hr className="my-3" />
              <div className="d-flex align-items-center justify-content-between">
                {hasApplied ? <div className="pill pill-success me-2 ">{formatMessage({ id: 'status_applied' })}</div> : <div />}
                <div className="button-mysynergie-icon p-0">
                  <MdArrowForward size={18} />
                </div>
              </div>
            </div>
          )}
        </Link>
      </div>
    </Col>
  );
}

export default JobTeaser;
